export default __webpack_public_path__ + "static/next-to-app-a8aa3c0886aba04277717d3ae2d1e507.svg";